<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Edit Doctor",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Edit Doctor",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },
               {
                  text: "Edit Doctor",
                  active: true,
               },        
            ],

            doctor: {},

            doctor_specializations: [],
            doctor_subspecializations: [],
            doctor_languages: [],
            certificates: [],
            bank: {
               account_holder_name: '',
               account_no: '',
               ifsc_code: '',
               upi_id: '',
            },

            errors: {},
            token: '',

            specializations: [],
            languages: [],

            all_specializations: [],
            all_languages: [],

            
            specialization: '',
            language: '',
            sub_specialization: '',

            countries: [],

            image: "",
            preview_image: "",

            proof_image: "",
            proof_preview_image: "",

            del_certificates_ids: [],

            all_subspecializations:[],

            certificates_inputs: [
                  {value: null, preview_image: null, image: null}
            ],
            certificates_images: [],
            certificates_image_id: [],

            today: current_date,
            
            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchDoctor();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchDoctor() {
            let url = "api/admin/doctors/details?doctor_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.doctor = responseData.doctor;  
               this.doctor_specializations = responseData.specializations;
               this.doctor_subspecializations = responseData.sub_specializations;
              
               this.doctor_languages = responseData.languages;

               this.certificates = responseData.certificates;

               if(responseData.bank_details.length) {
                  this.bank = responseData.bank_details[0];
               }
               if (responseData.specializations.length > 0) {
                  this.doctor.specialization = responseData.specializations[0].id; 
               }

                this.sub_specialization = responseData.sub_specializations.map(sub => ({
                  id: sub.id,
                  title: sub.sub_specialization
               }));
               

               for(var language of this.doctor_languages) {
                     let obj = {};
                     obj.id = language.id;
                     obj.title = language.language;
                     this.languages.push(obj);
               } 

               this.doctor.subspecializations = responseData.sub_specializations.map(sub => sub.id);


               this.fetchSpecializations(1);
               this.fetchLanguages(1);    
               this.fetchCountryCodes(); 
               this.fetchSubSpecializations(this.doctor.specialization);        
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         fetchSpecializations(type) {
            let url = "api/admin/get-specializations?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.all_specializations = responseData.specializations;
               })
               .catch((err) => console.log(err));
         },


         fetchSubSpecializations(specializationId) {
            if (!specializationId) return;
            if (this.doctor.specialization !== specializationId) {
               this.sub_specialization = []; 
               this.doctor.sub_specializations = [];
            }
            let url = `api/admin/get-subspecializations?specialization_id=${specializationId}`;
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  this.all_subspecializations = res.data.data.sub_specializations;
               })
               .catch((error) => {
                  console.error("Error fetching subspecializations:", error);
               });
         },

         fetchLanguages(type) {
            let url = "api/admin/get-languages?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.all_languages = responseData.languages;
               })
               .catch((err) => console.log(err));
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },



        addSubSpecialization() {
            if (!this.doctor.subspecializations) {
               this.doctor.subspecializations = [];
            }

            let selectedId = this.doctor.subspecializations; 
            let selectedSub = this.all_subspecializations.find(sub => sub.id == selectedId);

            if (selectedSub) {
               if (!Array.isArray(this.sub_specialization)) {
                     this.sub_specialization = [];
               }

               let exists = this.sub_specialization.some(sub => sub.id == selectedSub.id);

               if (!exists) {
                     this.sub_specialization.push({
                        id: selectedSub.id,
                        title: selectedSub.sub_specialization
                     });
               }
            }
         },

         removeSubSpecialization(index) {
               this.sub_specialization.splice(index, 1);
               this.doctor.sub_specializations.splice(index, 1);
         },

         addLanguage() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            //let index = event.target.options.selectedIndex;
            let id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.languages.some(function(language) {
               return id == language.id;
            });

            if(!exists) {
               this.languages.push({ id: id , title: text });
              }
            this.language = '';
         },

         removeLanguage(index) {
              this.languages.splice(index, 1);
         }, 

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         setProof(e) {
            this.proof_image = e.target.files[0];
            this.proof_preview_image = URL.createObjectURL(e.target.files[0]);
         },

         certificates_add() {
            this.certificates_inputs.push({ value: null });
         },

         certificates_remove(index) {
            this.certificates_inputs.splice(index, 1);
            this.certificates_images.splice(index, 1);
         }, 

         certificates_setFile(e, index) {
            this.certificates_images.push(e.target.files[0]);
            this.certificates_inputs[index].image = e.target.files[0];
            this.certificates_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },

         deleteCertificate(index, id) {
            this.del_certificates_ids.push(id);
            this.certificates.splice(index, 1);
         },


         updateDoctor() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctors/edit";             
       
            let formData = new FormData();
            formData.append("doctor_id", this.doctor.id);
            formData.append("name", this.doctor.name); 
            formData.append("mobile", this.doctor.mobile); 
            formData.append("country_code", this.doctor.country_code_id); 
            // formData.append("email", this.doctor.email); 
            if(this.doctor.email){
               formData.append("email",this.doctor.email); 
            } else{
               formData.append("email", ""); 
            }
            formData.append("age_type", this.doctor.age_type); 
            formData.append("age", this.doctor.age);  
            formData.append("dob", this.doctor.dob); 
            formData.append("gender", this.doctor.gender); 
            formData.append("prefix", this.doctor.prefix); 
            formData.append("qualification", this.doctor.qualification); 
            formData.append("current_hospital", this.doctor.current_hospital); 
            formData.append("address", this.doctor.address); 
            formData.append("reg_number", this.doctor.reg_no); 
            formData.append("reg_council", this.doctor.reg_council); 
            formData.append("reg_date", this.doctor.reg_date); 
            formData.append("start_date", this.doctor.start_at); 
            formData.append("commision", this.doctor.commision); 
            formData.append("convenience_fee", this.doctor.convenience_fee);
            formData.append("no_days_booking", this.doctor.no_days_booking); 
            formData.append("hide_prescription", this.doctor.hide_prescription); 
            formData.append("ask_symptoms", this.doctor.ask_symptoms); 
            formData.append("unlist", this.doctor.unlist); 
            formData.append("disable_sms", this.doctor.disable_sms); 
            formData.append("reserve_token", this.doctor.reserve_token); 
            formData.append("doctor_type", this.doctor.doctor_type);
            formData.append("confirm_screen", this.doctor.confirm_screen); 
            if(this.doctor.confirm_screen == '1' && this.doctor.confirm_screen_time) {
               formData.append("confirm_screen_time", this.doctor.confirm_screen_time);
            }
            formData.append("specializations", this.doctor.specialization);
             
            if(this.bank.account_no){
               formData.append("account_number", this.bank.account_no); 
            } else{
               formData.append("account_number", ""); 
            }
            if(this.bank.account_holder_name){
               formData.append("account_holder_name", this.bank.account_holder_name); 
            }else{
               formData.append("account_holder_name", ""); 
            }
            if(this.bank.ifsc_code){
               formData.append("ifsc_code", this.bank.ifsc_code); 
            }else{
               formData.append("ifsc_code", ""); 
            }
            if(this.bank.ifsc_code){
               formData.append("upi_id", this.bank.upi_id); 
            }else{
               formData.append("upi_id", ""); 
            }
            

            var sub_specialization = [];
            for(var i=0; i< this.sub_specialization.length; i++) {
               sub_specialization.push(this.sub_specialization[i].id);
            }

            var languages = [];
            for(var j=0; j< this.languages.length; j++) {
               languages.push(this.languages[j].id);
            } 

            formData.append('sub_specialization', JSON.stringify(sub_specialization));
            formData.append('languages', JSON.stringify(languages));

            if(this.image) {
               formData.append('image', this.image);
            }

            if(this.proof_image) {
               formData.append('id_proof', this.proof_image);
            }  

            formData.append('del_certificates_ids', JSON.stringify(this.del_certificates_ids));
            

            for(var k = 0; k < this.certificates_images.length; k++) {
               let file = this.certificates_images[k];
               formData.append('certificates[' + k + ']', file);
            }
           
            this.loading = true;
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'doctors'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form" @submit.prevent="updateDoctor()">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Personal Details</h4>
                           <div class="row">

                              <div class="form-group col-md-4">
                                 <label>Name <span class="text-danger">*</span></label>
                                 <!-- <b-input-group prepend="Dr."> -->
                                    <b-input-group>
                                    <b-input-group-prepend>
                                 <select class="form-control" v-model="doctor.prefix" v-bind:class="{ 'is-invalid': Boolean(errors.prefix) }">
                                    <option value="1">Dr</option>
                                    <option value="2">Mr</option>
                                    <option value="3">Ms</option>
                                    <option value="4">Others</option>
                                 </select>
                              </b-input-group-prepend>
                                    <input type="text" v-model="doctor.name" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" />
                                    <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-input-group>                                 
                              </div>                     
                          
                              <div class="form-group col-md-4">
                                 <label>Mobile Number <span class="text-danger">*</span></label>
                                 <b-input-group>
                                    <b-input-group-prepend>
                                       <select class="form-control" v-model="doctor.country_code_id">
                                          <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                       </select>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="doctor.mobile" @keypress="numbersOnly" maxlength="15" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-input-group>                                 
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Email </label>
                                 <input type="email" v-model="doctor.email" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>

                                 <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                                  <b-form-group class="col-lg-4 mb-3" v-if="doctor.age_type == 1">
                                 <label>
                                    Age <span class="text-danger">*</span>
                                    <span class="ml-2">
                                       <a href="#" @click.prevent="doctor.age_type = 2">Enter DOB Instead</a>
                                    </span>
                                 </label>

                                 <b-form-input
                                 type="number"
                                 v-model="doctor.age"
                                 min="1"
                                 class="form-control"
                                 :class="{ 'is-invalid': Boolean(errors.age) }"
                                 ></b-form-input>

                           <div v-for="(val, index) in errors.age" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-form-group>
                             
                              <div class="form-group col-md-4" v-if="doctor.age_type == 2">
                                 <label>Date of Birth <span class="text-danger">*</span><span class="ml-2">
                                    <a href="#" @click.prevent="doctor.age_type = 1">Enter Age Instead</a>
                                 </span></label>
                                 <input type="date" v-model="doctor.dob" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.dob) }" :max="today"/>

                                 <div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Gender <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="doctor.gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
                                    <option value="">Select</option>
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Others</option>
                                 </select>

                                 <div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Qualification <span class="text-danger">*</span></label>
                                 <input type="text" v-model="doctor.qualification" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.qualification) }"/>

                                 <div v-for="(val, index) in errors.qualification" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Currently Practicing Hospital </label>
                                 <input type="text" v-model="doctor.current_hospital" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.current_hospital) }"/>

                                 <div v-for="(val, index) in errors.current_hospital" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Start Date <span class="text-danger">*</span></label>
                                 <input type="date" v-model="doctor.start_at" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.start_date) }" :max="today"/>

                                 <div v-for="(val, index) in errors.start_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Address <span class="text-danger">*</span></label>
                                 <textarea rows="2" v-model="doctor.address" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></textarea>

                                 <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div> 
                            
                           </div>
                        </b-card>

                        <div class="row">
                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Specialization</h4>

                                 <div class="row">
                                    <div class="form-group col-12">                                   
                                       <select class="form-control" @change="fetchSubSpecializations($event.target.value)" v-model="doctor.specialization" v-bind:class="{ 'is-invalid': Boolean(errors.specializations) }">
                                          <option value="">Select</option>
                                          <option :value="specialization.id" v-for="specialization in all_specializations" :key="specialization.id">{{specialization.specialization}}</option>
                                       </select>

                                       <div v-for="(val, index) in errors.specializations" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>

                        
                                 </div>
                              </b-card>
                           </div>

                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Sub Specialization</h4>

                                 <div class="row">
                                    <div class="form-group col-12">
                                       <select class="form-control"  @change="addSubSpecialization()" v-model="doctor.subspecializations">
                                           <option value="">Select</option>
                                          <option v-for="subspecialization in all_subspecializations" :key="subspecialization.id" :value="subspecialization.id">
                                             {{ subspecialization.sub_specialization }}
                                          </option>
                                       </select>

                                       <div v-for="(val, index) in errors.subspecializations" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>

                                     <div class="col-12">
                                       <div class="input-tag" v-for="(sub, index) in sub_specialization" :key="index">
                                             <p>{{ sub.title }}<span @click="removeSubSpecialization(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                                 </div>
                              </b-card>
                           </div>


                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Languages</h4>

                                 <div class="row">
                                    <div class="form-group col-12">
                                       <select class="form-control" @change="addLanguage()" v-model="this.language" v-if="all_languages.length">
                                          <option value="">Select</option>
                                          <option :value="language.id" v-for="language in all_languages" :key="language.id">{{language.language}}</option>
                                       </select>

                                       <div v-for="(val, index) in errors.languages" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(language, index) in languages" :key="index">
                                             <p>{{ language.title }}<span @click="removeLanguage(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                                 </div>

                              </b-card>
                           </div>
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>

                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Reg. No. <span class="text-danger">*</span></label>
                                 <input type="text" v-model="doctor.reg_no" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.reg_number) }"/>

                                 <div v-for="(val, index) in errors.reg_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Council <span class="text-danger">*</span></label>
                                 <input type="text" v-model="doctor.reg_council" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.reg_council) }"/>

                                 <div v-for="(val, index) in errors.reg_council" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Date <span class="text-danger">*</span></label>
                                 <input type="date" v-model="doctor.reg_date" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.reg_date) }"/>

                                 <div v-for="(val, index) in errors.reg_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Account No.</label>
                                 <input type="text" v-model="bank.account_no" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.account_number) }" @keypress="numbersOnly" maxlength="20" />

                                 <div v-for="(val, index) in errors.account_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>Account Holder Name </label>
                                 <input type="text" v-model="bank.account_holder_name" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.account_holder_name) }"/>

                                 <div v-for="(val, index) in errors.account_holder_name" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>IFSC Code </label>
                                 <input type="text" v-model="bank.ifsc_code" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.ifsc_code) }" maxlength="11" />

                                 <div v-for="(val, index) in errors.ifsc_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>UPI ID </label>
                                 <input type="text" v-model="bank.upi_id" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.upi_id) }" maxlength="50" />

                                 <div v-for="(val, index) in errors.upi_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                 <img class="avatar-md mb-2" v-if="doctor.image" :src="$image_url + doctor.image" alt="">
                                 <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                                 <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 
                              </div>
                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>ID Proof <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <img class="avatar-md mb-2" v-if="doctor.id_proof" :src="$image_url + doctor.id_proof" alt="">
                                 <input type="file" @change="setProof($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.id_proof) }" />
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>

                                 <img v-if="proof_preview_image" class="avatar-sm mt-2" :src="proof_preview_image">

                                 <div v-for="(val, index) in errors.id_proof" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Certificates <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row mb-3">
                              <div class="col-2 mb-2 d-flex" v-for="(certificate, index) in certificates" :key="index">

                                 <div class="del-wrapper" style="position: relative">
                                    <!-- <a :href="$image_url + certificate.certificate" target="_blank" class="font-size-22"><p class="text-primary"><i class="fas fa-file-alt me-3"></i></p></a> --> 

                                    <a :href="$image_url + certificate.certificate" target="_blank"><img :src="$image_url + certificate.certificate" alt="" style="max-width: 100px"></a>
                                    <a href="#" class="del-icon text-danger" @click.prevent="deleteCertificate(index, certificate.id)"><i class="fas fa-times-circle"></i></a>
                                 </div>

                              </div>
                           </div>

                           <b-row v-for="(input, index) in certificates_inputs" :key="index">    
                              <b-col md="6" class="form-group">
                                 <div class="w-90">
                                    <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="certificates_setFile($event, index)"></b-form-file>
                                 </div>

                                 <span class="ml-1 mt-2">
                                    <i class="fas fa-minus-circle text-danger" @click="certificates_remove(index)" v-show="index || ( !index && certificates_inputs.length > 1)"></i>
                                    <i class="fas fa-plus-circle text-success" @click="certificates_add()" v-show="index == certificates_inputs.length-1"></i>
                                 </span>
                              </b-col>
                              <b-col md="6">
                                 <img v-if="input.preview_image" class="avatar-sm mt-2" v-bind:src="input.preview_image">
                              </b-col>
                           </b-row>

                           <div v-for="(val, index) in errors.certificates" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Other Settings</h4>
                           <div class="row">
                          <div class="col-lg-6">
                                 <div class="form-group">
                                    <label>Ask questions regarding the patient's symptoms</label>
                                    <b-form-radio-group v-model="doctor.ask_symptoms" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="symptom_needed"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="symptom_needed" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>

                                 <div class="form-group">
                                    <label>Disable SMS service</label>
                                    <b-form-radio-group v-model="doctor.disable_sms" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="sms_needed"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="sms_needed" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>

                                 <div class="form-group">
                                    <label>Unlist from doctors listing</label>
                                    <b-form-radio-group v-model="doctor.unlist" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_doctor"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_doctor" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>
                                 <div class="form-group">
                                    <label>Reserve clinic tokens</label>
                                    <b-form-radio-group v-model="doctor.reserve_token" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="sms_needed"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="sms_needed" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>

                                 <!-- <div class="form-group">
                                    <label>Unlist from clinics listing</label>
                                    <b-form-radio-group v-model="doctor.unlist_clinic" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div> -->

                                 <div class="form-group">
                                    <label>Hide prescription from other doctors</label>
                                    <b-form-radio-group v-model="doctor.hide_prescription" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>
                              </div>
                              <div class="col-lg-6">
                                 <div class="form-group">
                                    <label>Convenience Fee<span class="text-danger">*</span></label>
                                    <b-input-group prepend="Rs.">
                                       <b-form-input type="number" min="0"  v-model="doctor.convenience_fee"  v-bind:class="{ 'is-invalid': Boolean(errors.convenience_fee) }"></b-form-input>
                                       <div v-for="(val, index) in errors.convenience_fee" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </b-input-group>
                                 </div>
                                 <div class="form-group">
                                 <label class="control-label">Platform Fee<span class="text-danger">*</span></label>
                                 <b-input-group prepend="Rs.">
                                 <b-form-input type="number" min="0"  v-model="doctor.commision"  v-bind:class="{ 'is-invalid': Boolean(errors.commision) }"></b-form-input>
                                 
                                 <div v-for="(val, index) in errors.commision" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>

                              </div>
                              <div class="form-group">
                                    <label>No. of days to show for booking</label>
                                    <b-input-group append="days">
                                       <input type="text" class="form-control" v-model="doctor.no_days_booking"  />
                                    </b-input-group>
                                 </div>
                                 <div class="form-group">
                                    <b-form-checkbox
                                       v-model="doctor.doctor_type"
                                       name="premium"
                                       value="1"
                                       unchecked-value="2"
                                    >
                                       <span class="ms-2">Premium Doctor</span>
                                    </b-form-checkbox>
                                 </div>
                                 <div class="form-group">
                                    <b-form-checkbox
                                       v-model="doctor.confirm_screen"
                                       name="confirmation_screen"
                                       value="1"
                                       unchecked-value="2"
                                    >
                                       <span class="ms-2">Confirmation Screen (TVM)</span>
                                    </b-form-checkbox>
                                 </div>
                              </div>
                           </div>

                           <!-- Conditional time input for confirmation screen -->
                           <div class="row mt-3" v-if="doctor.confirm_screen == '1'">
                              <b-col md="12" lg="6" class="form-group">
                                 <label class="control-label">Confirmation Screen Time (seconds)<span class="text-danger">*</span></label>
                                 <b-form-input 
                                    v-model="doctor.confirm_screen_time" 
                                    type="number" 
                                    min="1"
                                    placeholder="Enter time in seconds"
                                    v-bind:class="{ 'is-invalid': Boolean(errors.confirm_screen_time) }"
                                 ></b-form-input>
                                 <div v-for="(val, index) in errors.confirm_screen_time" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                           </div>

                        </b-card>
                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
